import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithDrive_1 from '../../../../../libraries/Images/createAConnectionWithDrive_1.png';
import createAConnectionWithDrive_2 from '../../../../../libraries/Images/createAConnectionWithDrive_2.png';
import createAConnectionWithDrive_3 from '../../../../../libraries/Images/createAConnectionWithDrive_3.png';
import createAConnectionWithDrive_4 from '../../../../../libraries/Images/createAConnectionWithDrive_4.png';
import createAConnectionWithDrive_5 from '../../../../../libraries/Images/createAConnectionWithDrive_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithdrive">
                1.&nbsp;{translate('createaconnectionwithdrive')}
            </Typography>
            <p>接続を作成するように"新規追加"ボタンをクリック</p>
            <Zoom>
                <img src={createAConnectionWithDrive_1} width="75%" />
            </Zoom>
            <p>連携できるアプリの一覧が表示されるので、その中から「Google Drive」を選択します。</p>
            <Zoom>
                <img src={createAConnectionWithDrive_2} width="75%" />
            </Zoom>
            <p>「Google Drive」をクリックすると、ユーザーのGoogleアカウント選択画面が表示されます。接続に使用するアカウントを選択してください。</p>
            <Zoom>
                <img src={createAConnectionWithDrive_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>アカウントを選択すると、「RPA CLOUD」がユーザーに代わってアクセスを要求します。 「RPA CLOUD」に上記のアクセス権限を付与することに同意し、「許可」をクリックします。</p>
            <Zoom>
                <img src={createAConnectionWithDrive_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>接続が正常に作成されると、ドライブ カードが表示されます。</p>
            <Zoom>
                <img src={createAConnectionWithDrive_5} width="50%"/>
            </Zoom>
            <p>このタグに含まれる<strong>プロバイダ ID</strong> を使用して、ドライブで手順を実行します。</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);